@if (isTypeX) {
  <img src="/assets/svg/airContainerTypeX.svg" alt="" />
}
@if (isTypeY) {
  <img src="/assets/svg/airContainerTypeY.svg" alt="" />
}
